import CardBack from '@/components/card/CardBack';
import { HandCardState } from '@/types/game';
import { getHandCardView } from '@/utils/handView';

interface HandCardPreviewModalProps {
  card: HandCardState | null;
  onClose: () => void;
  viewerId?: string | null;
}

export default function HandCardPreviewModal({ card, onClose, viewerId }: HandCardPreviewModalProps) {
  if (!card) {
    return null;
  }

  const view = getHandCardView(card, viewerId);
  const caption = card.name || (view.showFrontFace ? 'Card' : 'Card back');
  const statusText = view.isOwner
    ? view.isRevealedToOthers
      ? 'Shown to opponents'
      : 'Hidden from opponents'
    : view.isRevealedToOthers
      ? 'Visible to you'
      : 'Hidden by opponent';

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm"
      onClick={onClose}
    >
      <div
        className="relative"
        onClick={(event) => event.stopPropagation()}
      >
        <button
          type="button"
          onClick={onClose}
          className="absolute -top-12 right-0 bg-white/20 hover:bg-white/40 text-white rounded-full p-2 transition"
          aria-label="Close hand preview"
        >
          ✕
        </button>
        <div className="rounded-lg overflow-hidden shadow-2xl border border-white/10">
          <div
            className="w-[300px] md:w-[420px] lg:w-[520px]"
            style={{ aspectRatio: '96 / 140' }}
          >
            {view.showFrontFace && view.displayImageUrl ? (
              <img
                src={view.displayImageUrl}
                alt={caption}
                className="h-full w-full object-contain"
                draggable={false}
                loading="lazy"
              />
            ) : (
              <CardBack backImageUrl={view.backImageUrl} className="h-full w-full" />
            )}
          </div>
        </div>
        <div className="mt-2 space-y-1 text-center text-sm text-white">
          <div>{caption}</div>
          <div className="text-xs text-white/70">{statusText}</div>
        </div>
      </div>
    </div>
  );
}
